import { StructuredData } from './StructuredData';

interface OrganizationSchemaProps {
  includeWebSite?: boolean;
}

/**
 * OrganizationSchema - Site-wide Organization + WebSite structured data
 *
 * Use on homepage and major landing pages.
 * Includes sitelinks search box for Google search integration.
 *
 * Usage:
 * <OrganizationSchema includeWebSite={true} />
 */
export const OrganizationSchema: React.FC<OrganizationSchemaProps> = ({
  includeWebSite = false,
}) => {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'TradeMagic',
    alternateName: 'Trade Magic',
    url: 'https://trademagic.gg',
    logo: 'https://trademagic.gg/logo512.png', // TODO: Update with actual logo URL
    description:
      'The easiest way to trade Magic: The Gathering cards. Join the best community of MTG players trading cards by mail.',
    foundingDate: '2025',
    sameAs: [
      'https://twitter.com/trademagic_gg',
      'https://discord.gg/F95FZGtn66',
      'https://www.reddit.com/r/TradeMagic/',
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'support@trademagic.gg',
      contactType: 'Customer Support',
    },
  };

  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'TradeMagic',
    url: 'https://trademagic.gg',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://trademagic.gg/search/results?name={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <StructuredData data={organizationSchema} />
      {includeWebSite && <StructuredData data={webSiteSchema} />}
    </>
  );
};
